var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 12,
    fill: "#00BB8E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2729_15900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1658 19.9484C12.4847 19.7345 10.9481 18.8885 9.86841 17.5824C8.78869 16.2763 8.24682 14.608 8.35294 12.9167C8.45906 11.2254 9.2052 9.63799 10.4397 8.47707C11.6742 7.31614 13.3045 6.66885 14.9991 6.66675C16.6958 6.66549 18.3291 7.3112 19.5663 8.47231C20.8035 9.63343 21.5514 11.2226 21.6576 12.9159C21.7639 14.6093 21.2205 16.2795 20.1381 17.5861C19.0558 18.8928 17.516 19.7376 15.8324 19.9484V22.5001H14.1658V19.9484ZM14.9991 18.3334C16.3252 18.3334 17.5969 17.8066 18.5346 16.869C19.4723 15.9313 19.9991 14.6595 19.9991 13.3334C19.9991 12.0073 19.4723 10.7356 18.5346 9.79788C17.5969 8.8602 16.3252 8.33342 14.9991 8.33342C13.673 8.33342 12.4012 8.8602 11.4636 9.79788C10.5259 10.7356 9.99909 12.0073 9.99909 13.3334C9.99909 14.6595 10.5259 15.9313 11.4636 16.869C12.4012 17.8066 13.673 18.3334 14.9991 18.3334ZM9.16575 23.3334H20.8324V25.0001H9.16575V23.3334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2729_15900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnified);
export default __webpack_public_path__ + "static/media/unified.b772a3fc9c252d27f16c5c610c4a4b66.svg";
export { ForwardRef as ReactComponent };